import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { decorators } from "@orange-marmalade/paginate-this";

import {
  APPLICATIONS,
  HIGHER_ASSEMBLY_APPLICATION,
  LOWER_ASSEMBLY_APPLICATION,
  ENGINE_APPLICATION,
  AIRCRAFT_APPLICATION
} from "MODULES/parts/constants";

import { groupBy } from "LIB/arrays";
import Application from "./Application";

function renderHeader(applicationType) {
  return (
    <tr>
      <th style={{ textAlign: "left" }}>
        {APPLICATIONS[applicationType].label}
      </th>
    </tr>
  );
}

export function renderGroup(records) {
  return (
    <tr>
      <td width="100%">
        {_.orderBy(records, [r => r.label]).map(r => (
          <Application application={r} key={r.id} />
        ))}
      </td>
    </tr>
  );
}

export function Table({ results }) {
  if (!results.length) {
    return false;
  }

  const groups = groupBy(results, "type");
  const header = name => groups[name] && renderHeader(name);
  const group = name => groups[name] && renderGroup(groups[name]);

  return (
    <table className="table table-condensed">
      <tbody>
        {header(AIRCRAFT_APPLICATION)}
        {group(AIRCRAFT_APPLICATION)}
        {header(ENGINE_APPLICATION)}
        {group(ENGINE_APPLICATION)}
        {header(HIGHER_ASSEMBLY_APPLICATION)}
        {group(HIGHER_ASSEMBLY_APPLICATION)}
        {header(LOWER_ASSEMBLY_APPLICATION)}
        {group(LOWER_ASSEMBLY_APPLICATION)}
      </tbody>
    </table>
  );
}

Table.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired
    })
  )
};

const Decorated = decorators.tabulate(Table);

export default () => <Decorated listId="part/applications" />;



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Applications/Table.jsx